import { getColumnIndexFromDate } from "./getColumnIndexFromDate";

/**
 * Used to format the data of the daily management type report and calculated the total sum per row
 *
 * The data is reversed, from grouped by date to grouped by type
 */
export function formatDailyManagementData({ rawData = [] } = {}) {
  const receivedCalls = {
    description: "Llamadas recibidas",
  };

  const attendedCalls = {
    description: "Llamadas atendidas",
  };

  const NSCalls = {
    description: "Llamadas atendidas NS",
  };

  const abandonedCalls = {
    description: "Llamadas abandonadas",
  };

  const attentionLevel = {
    description: "% Nivel de atención",
  };

  const serviceLevel = {
    description: "% Nivel de servicio",
  };

  const abandonedLevel = {
    description: "% Nivel de abandono",
  };

  const tmo = {
    description: "TMO",
  };

  const tme = {
    description: "TME",
  };

  const tiempo_hablado = {
    description: "TH",
  };

  const tiempo_tipificado = {
    description: "TT",
  };

  const totals = {
    receivedCalls: 0,
    attendedCalls: 0,
    NSCalls: 0,
    abandonedCalls: 0,
    attentionLevel: 0,
    serviceLevel: 0,
    abandonedLevel: 0,
    tmo: 0,
    tme: 0,
    tiempo_hablado: 0,
    tiempo_tipificado: 0,
  };

  rawData.forEach((item) => {
    const columnIndex = getColumnIndexFromDate({ date: item.fecha });

    // Set the value per day in each type object
    receivedCalls[columnIndex] = item.recibidas;
    attendedCalls[columnIndex] = item.atendidas;
    NSCalls[columnIndex] = item.atendidas_ns;
    abandonedCalls[columnIndex] = item.abandonadas;
    attentionLevel[columnIndex] = item.nivel_atencion;
    serviceLevel[columnIndex] = item.nivel_servicio;
    abandonedLevel[columnIndex] = item.nivel_abandono;
    tmo[columnIndex] = item.tmo;
    tme[columnIndex] = item.tme;
    tiempo_hablado[columnIndex] = item.tiempo_hablado;
    tiempo_tipificado[columnIndex] = item.tiempo_tipificado;

    // Object with the total sum of each type
    totals.receivedCalls += item.recibidas;
    totals.attendedCalls += item.atendidas;
    totals.NSCalls += item.atendidas_ns;
    totals.abandonedCalls += item.abandonadas;
    totals.attentionLevel += item.nivel_atencion;
    totals.serviceLevel += item.nivel_servicio;
    totals.abandonedLevel += item.nivel_abandono;
    totals.tmo += item.tmo;
    totals.tme += item.tme;
    totals.tiempo_hablado += item.tiempo_hablado;
    totals.tiempo_tipificado += item.tiempo_tipificado;
  });

  return [
    { ...receivedCalls, total: totals.receivedCalls },
    { ...attendedCalls, total: totals.attendedCalls },
    { ...NSCalls, total: totals.NSCalls },
    { ...abandonedCalls, total: totals.abandonedCalls },
    { ...attentionLevel, total: totals.attentionLevel },
    { ...serviceLevel, total: totals.serviceLevel },
    { ...abandonedLevel, total: totals.abandonedLevel },
    { ...tmo, total: totals.tmo },
    { ...tme, total: totals.tme },
    { ...tiempo_hablado, total: totals.tiempo_hablado },
    { ...tiempo_tipificado, total: totals.tiempo_tipificado },
  ];
}
